import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { DynamicIcon } from "@/lib/icons";

export function CategoryCards({ categories = [], variant = "desktop" }) {
  if (variant === "mobile") {
    return (
      <div className="grid grid-cols-3 gap-2.5" data-testid="category-grid-mobile">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/boutique?categorie=${cat.slug}`}
            data-testid={`mobile-category-${cat.slug}`}
            className="flex flex-col items-center gap-2 rounded-xl border border-line bg-white px-2 py-3.5 transition-colors duration-200 active:bg-brand-soft"
          >
            <span
              className="flex h-9 w-9 items-center justify-center rounded-lg"
              style={{ backgroundColor: `${cat.color}14`, color: cat.color }}
            >
              <DynamicIcon name={cat.icon} className="h-5 w-5" />
            </span>
            <span className="text-center text-[10.5px] font-bold leading-tight text-ink">{cat.name}</span>
          </Link>
        ))}
      </div>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-testid="category-grid">
      {categories.map((cat, i) => (
        <Link
          key={cat.slug}
          to={`/boutique?categorie=${cat.slug}`}
          data-testid={`category-card-${cat.slug}`}
          style={{ animationDelay: `${i * 50}ms` }}
          className="group animate-fade-up rounded-2xl border border-line bg-white p-6 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-brand/30 hover:shadow-[0_20px_40px_rgba(0,0,0,0.08)]"
        >
          <span
            className="flex h-12 w-12 items-center justify-center rounded-xl transition-transform duration-300 group-hover:scale-110"
            style={{ backgroundColor: `${cat.color}16`, color: cat.color }}
          >
            <DynamicIcon name={cat.icon} className="h-6 w-6" />
          </span>
          <h3 className="mt-5 font-display text-lg font-bold text-ink">{cat.name}</h3>
          <p className="mt-1.5 text-sm leading-snug text-slate-500">{cat.description}</p>
          <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-brand">
            Découvrir
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </span>
        </Link>
      ))}
    </div>
  );
}

export default CategoryCards;
